import { render } from "./second-button.vue?vue&type=template&id=084a8b7d&ts=true"
import script from "./second-button.vue?vue&type=script&lang=ts"
export * from "./second-button.vue?vue&type=script&lang=ts"

import "./second-button.vue?vue&type=style&index=0&id=084a8b7d&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__